<div id="scroll">
    <span>^</span>
</div>
<div class="footer">
    <div class="conta_iner">
        <p>© 2022 by Russian Anabolics
            <!-- :: Developed & Designed By: <a href="https://webincline.com/" target="_blank">Webincline</a> -->
        </p>
    </div>
</div>